import type { Locale } from '@change-corgi/config/locales';

import { useL10n } from './context';

export function useLocale(): Locale {
	return useL10n().locale;
}
